import React from "react";
import { Box } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import eligibilityImage from "../../images/z-for-her-eligibility.png";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', serif" };

const REQUIREMENTS = [
  "You have an active Zikora current account",
  "Your account shows regular activity",
  "You run a business or trade",
  "You can provide basic identification (BVN, valid ID)",
  "You are based in Anambra State",
];

const Eligibility = () => {
  return (
    <Box
      sx={{
        background: "transparent",
        boxSizing: "border-box",
        padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        <div
          className="flex sm:flex-col"
          style={{ gap: "clamp(32px, 4.44vw, 64px)", alignItems: "stretch" }}
        >
          {/* Left column */}
          <div
            className="flex flex-col"
            style={{ flex: "1 1 0", minWidth: 0, gap: "clamp(24px, 2.78vw, 40px)" }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(12px, 1.39vw, 20px)",
              }}
            >
              {/* Label */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#295B4A",
                    flexShrink: 0,
                    display: "inline-block",
                  }}
                />
                <span
                  style={{
                    ...geistMono,
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: 1,
                    letterSpacing: "0.1em",
                    color: "#295B4A",
                    textTransform: "uppercase",
                  }}
                >
                  Eligibility
                </span>
              </div>

              <h2
                style={{
                  ...instrumentSerif,
                  fontWeight: 400,
                  fontSize: "clamp(32px, 4.17vw, 60px)",
                  lineHeight: 1.1,
                  letterSpacing: "-0.01em",
                  color: "#132A22",
                  margin: 0,
                }}
              >
                Who can Apply
              </h2>

              <p
                style={{
                  ...raleway,
                  fontWeight: 400,
                  fontSize: "clamp(14px, 1.25vw, 18px)",
                  lineHeight: 1.6,
                  color: "#3F5445",
                  margin: 0,
                }}
              >
                See if you meet the basic requirements to get started.
              </p>
            </div>

            {/* Requirements list */}
            <div
              className="flex flex-col"
              style={{ gap: "12px" }}
            >
              {REQUIREMENTS.map((req) => (
                <Box
                  key={req}
                  sx={{
                    background: "#FFFFFF",
                    borderRadius: "10px",
                    padding: "16px 20px",
                    boxShadow: "0px 4px 12px rgba(10, 13, 18, 0.04)",
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                  }}
                >
                  <FaRegCheckCircle
                    size={22}
                    color="#295B4A"
                    style={{ flexShrink: 0 }}
                  />
                  <p
                    style={{
                      ...raleway,
                      fontWeight: 500,
                      fontSize: "clamp(14px, 1.11vw, 16px)",
                      lineHeight: 1.5,
                      color: "#132A22",
                      margin: 0,
                    }}
                  >
                    {req}
                  </p>
                </Box>
              ))}
            </div>
          </div>

          {/* Right image */}
          <div
            className="sm:w-full sm:hidden"
            style={{ flex: "1 1 0", minWidth: 0 }}
          >
            <img
              src={eligibilityImage}
              alt="Woman entrepreneur"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "clamp(320px, 50vw, 600px)",
                objectFit: "cover",
                borderRadius: "16px",
                display: "block",
              }}
            />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Eligibility;
